/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlatformApiResultOfBoolean } from '../models/platform-api-result-of-boolean';
import { PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto } from '../models/platform-api-result-of-data-source-result-dto-of-present-device-user-info-dto';
import { PlatformApiResultOfUserInfo } from '../models/platform-api-result-of-user-info';
import { PlatformApiResultOfUserInfoDto } from '../models/platform-api-result-of-user-info-dto';
import { postUserpresenceActionClearaanmelden } from '../fn/user-presence/post-userpresence-action-clearaanmelden';
import { PostUserpresenceActionClearaanmelden$Params } from '../fn/user-presence/post-userpresence-action-clearaanmelden';
import { postUserpresenceActionDesktopafmelden } from '../fn/user-presence/post-userpresence-action-desktopafmelden';
import { PostUserpresenceActionDesktopafmelden$Params } from '../fn/user-presence/post-userpresence-action-desktopafmelden';
import { postUserpresenceActionDesktopmanueelaanmelden } from '../fn/user-presence/post-userpresence-action-desktopmanueelaanmelden';
import { PostUserpresenceActionDesktopmanueelaanmelden$Params } from '../fn/user-presence/post-userpresence-action-desktopmanueelaanmelden';
import { postUserpresenceActionDeviceuserlogoff } from '../fn/user-presence/post-userpresence-action-deviceuserlogoff';
import { PostUserpresenceActionDeviceuserlogoff$Params } from '../fn/user-presence/post-userpresence-action-deviceuserlogoff';
import { postUserpresenceActionForceinvalidateallusers } from '../fn/user-presence/post-userpresence-action-forceinvalidateallusers';
import { PostUserpresenceActionForceinvalidateallusers$Params } from '../fn/user-presence/post-userpresence-action-forceinvalidateallusers';
import { postUserpresenceActionForceinvalidateuser } from '../fn/user-presence/post-userpresence-action-forceinvalidateuser';
import { PostUserpresenceActionForceinvalidateuser$Params } from '../fn/user-presence/post-userpresence-action-forceinvalidateuser';
import { postUserpresenceActionForcestopallusers } from '../fn/user-presence/post-userpresence-action-forcestopallusers';
import { PostUserpresenceActionForcestopallusers$Params } from '../fn/user-presence/post-userpresence-action-forcestopallusers';
import { postUserpresenceActionForcestopuser } from '../fn/user-presence/post-userpresence-action-forcestopuser';
import { PostUserpresenceActionForcestopuser$Params } from '../fn/user-presence/post-userpresence-action-forcestopuser';
import { postUserpresenceActionOleaanwezigmelden } from '../fn/user-presence/post-userpresence-action-oleaanwezigmelden';
import { PostUserpresenceActionOleaanwezigmelden$Params } from '../fn/user-presence/post-userpresence-action-oleaanwezigmelden';
import { postUserpresenceActionOleappopenen } from '../fn/user-presence/post-userpresence-action-oleappopenen';
import { PostUserpresenceActionOleappopenen$Params } from '../fn/user-presence/post-userpresence-action-oleappopenen';
import { postUserpresenceActionOleeindewerkdag } from '../fn/user-presence/post-userpresence-action-oleeindewerkdag';
import { PostUserpresenceActionOleeindewerkdag$Params } from '../fn/user-presence/post-userpresence-action-oleeindewerkdag';
import { postUserpresenceQueryCustomdatasource } from '../fn/user-presence/post-userpresence-query-customdatasource';
import { PostUserpresenceQueryCustomdatasource$Params } from '../fn/user-presence/post-userpresence-query-customdatasource';

@Injectable({ providedIn: 'root' })
export class PlatformUserPresenceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postUserpresenceActionDeviceuserlogoff()` */
  static readonly PostUserpresenceActionDeviceuserlogoffPath = '/api/userpresence/action/deviceuserlogoff';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionDeviceuserlogoff()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionDeviceuserlogoff$Response(params?: PostUserpresenceActionDeviceuserlogoff$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionDeviceuserlogoff(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionDeviceuserlogoff$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionDeviceuserlogoff(params?: PostUserpresenceActionDeviceuserlogoff$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionDeviceuserlogoff$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionDesktopmanueelaanmelden()` */
  static readonly PostUserpresenceActionDesktopmanueelaanmeldenPath = '/api/userpresence/action/desktopmanueelaanmelden';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionDesktopmanueelaanmelden()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionDesktopmanueelaanmelden$Response(params: PostUserpresenceActionDesktopmanueelaanmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfoDto>> {
    return postUserpresenceActionDesktopmanueelaanmelden(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionDesktopmanueelaanmelden$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionDesktopmanueelaanmelden(params: PostUserpresenceActionDesktopmanueelaanmelden$Params, context?: HttpContext): Observable<PlatformApiResultOfUserInfoDto> {
    return this.postUserpresenceActionDesktopmanueelaanmelden$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserInfoDto>): PlatformApiResultOfUserInfoDto => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionClearaanmelden()` */
  static readonly PostUserpresenceActionClearaanmeldenPath = '/api/userpresence/action/clearaanmelden';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionClearaanmelden()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionClearaanmelden$Response(params: PostUserpresenceActionClearaanmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionClearaanmelden(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionClearaanmelden$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionClearaanmelden(params: PostUserpresenceActionClearaanmelden$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionClearaanmelden$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionDesktopafmelden()` */
  static readonly PostUserpresenceActionDesktopafmeldenPath = '/api/userpresence/action/desktopafmelden';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionDesktopafmelden()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionDesktopafmelden$Response(params?: PostUserpresenceActionDesktopafmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionDesktopafmelden(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionDesktopafmelden$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionDesktopafmelden(params?: PostUserpresenceActionDesktopafmelden$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionDesktopafmelden$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionOleappopenen()` */
  static readonly PostUserpresenceActionOleappopenenPath = '/api/userpresence/action/oleappopenen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionOleappopenen()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleappopenen$Response(params: PostUserpresenceActionOleappopenen$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserInfo>> {
    return postUserpresenceActionOleappopenen(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionOleappopenen$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleappopenen(params: PostUserpresenceActionOleappopenen$Params, context?: HttpContext): Observable<PlatformApiResultOfUserInfo> {
    return this.postUserpresenceActionOleappopenen$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfUserInfo>): PlatformApiResultOfUserInfo => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionOleaanwezigmelden()` */
  static readonly PostUserpresenceActionOleaanwezigmeldenPath = '/api/userpresence/action/oleaanwezigmelden';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionOleaanwezigmelden()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleaanwezigmelden$Response(params: PostUserpresenceActionOleaanwezigmelden$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionOleaanwezigmelden(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionOleaanwezigmelden$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleaanwezigmelden(params: PostUserpresenceActionOleaanwezigmelden$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionOleaanwezigmelden$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionOleeindewerkdag()` */
  static readonly PostUserpresenceActionOleeindewerkdagPath = '/api/userpresence/action/oleeindewerkdag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionOleeindewerkdag()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleeindewerkdag$Response(params: PostUserpresenceActionOleeindewerkdag$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionOleeindewerkdag(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionOleeindewerkdag$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionOleeindewerkdag(params: PostUserpresenceActionOleeindewerkdag$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionOleeindewerkdag$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionForcestopuser()` */
  static readonly PostUserpresenceActionForcestopuserPath = '/api/userpresence/action/forcestopuser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionForcestopuser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionForcestopuser$Response(params: PostUserpresenceActionForcestopuser$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionForcestopuser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionForcestopuser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionForcestopuser(params: PostUserpresenceActionForcestopuser$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionForcestopuser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionForcestopallusers()` */
  static readonly PostUserpresenceActionForcestopallusersPath = '/api/userpresence/action/forcestopallusers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionForcestopallusers()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionForcestopallusers$Response(params?: PostUserpresenceActionForcestopallusers$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionForcestopallusers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionForcestopallusers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionForcestopallusers(params?: PostUserpresenceActionForcestopallusers$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionForcestopallusers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionForceinvalidateuser()` */
  static readonly PostUserpresenceActionForceinvalidateuserPath = '/api/userpresence/action/forceinvalidateuser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionForceinvalidateuser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionForceinvalidateuser$Response(params: PostUserpresenceActionForceinvalidateuser$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionForceinvalidateuser(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionForceinvalidateuser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceActionForceinvalidateuser(params: PostUserpresenceActionForceinvalidateuser$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionForceinvalidateuser$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceActionForceinvalidateallusers()` */
  static readonly PostUserpresenceActionForceinvalidateallusersPath = '/api/userpresence/action/forceinvalidateallusers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceActionForceinvalidateallusers()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionForceinvalidateallusers$Response(params?: PostUserpresenceActionForceinvalidateallusers$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfBoolean>> {
    return postUserpresenceActionForceinvalidateallusers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceActionForceinvalidateallusers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postUserpresenceActionForceinvalidateallusers(params?: PostUserpresenceActionForceinvalidateallusers$Params, context?: HttpContext): Observable<PlatformApiResultOfBoolean> {
    return this.postUserpresenceActionForceinvalidateallusers$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfBoolean>): PlatformApiResultOfBoolean => r.body)
    );
  }

  /** Path part for operation `postUserpresenceQueryCustomdatasource()` */
  static readonly PostUserpresenceQueryCustomdatasourcePath = '/api/userpresence/query/customdatasource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postUserpresenceQueryCustomdatasource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceQueryCustomdatasource$Response(params: PostUserpresenceQueryCustomdatasource$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto>> {
    return postUserpresenceQueryCustomdatasource(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postUserpresenceQueryCustomdatasource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postUserpresenceQueryCustomdatasource(params: PostUserpresenceQueryCustomdatasource$Params, context?: HttpContext): Observable<PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto> {
    return this.postUserpresenceQueryCustomdatasource$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto>): PlatformApiResultOfDataSourceResultDtoOfPresentDeviceUserInfoDto => r.body)
    );
  }

}
